
if ( document.getElementById('mobile-nav-toggle') ) {
  document.addEventListener('DOMContentLoaded', function() {
    document.getElementById('mobile-nav-toggle').addEventListener( 'click', function() {
  		document.getElementById('primary-menu-list').classList.toggle('display');

  		if ( document.getElementById( 'mobile-nav-toggle' ).getAttribute( 'aria-expanded' ) === 'true' ) {
  			document.getElementById( 'mobile-nav-toggle' ).setAttribute( 'aria-expanded', 'false' );
  		} else {
  			document.getElementById( 'mobile-nav-toggle' ).setAttribute( 'aria-expanded', 'true' );
  		}
  		document.getElementById('mobile-nav-toggle').classList.toggle('toggled-on');
  	});
  });
}

;
// @codekit-prepend "nav.js"

/********************************************************************
 Load more posts button on home blog page
 ********************************************************************/

// if the load more button exists then watch it for a click
if (document.getElementById('load-more')) {
    watchTheLoadMorePostsButton();
}

function watchTheLoadMorePostsButton() {
    const loadMoreButton = document.getElementById('load-more');

    if (!loadMoreButton) {
        return;
    }

    loadMoreButton.addEventListener(
        'click',
        function (event) {
            event.preventDefault();

            const currentHref = loadMoreButton.getAttribute('href') || '';
            const currentPage = Number.parseInt(loadMoreButton.dataset.page || '1', 10);
            const nextPage = currentPage + 1;
            const requestQuery = parseLoadMoreQuery(loadMoreButton.dataset.query || '');
            const requestQuerySignature = loadMoreButton.dataset.querySignature || '';
            const nextHref = getIncrementedPageUrl(currentHref);

            loadMoreButton.remove();
            document.getElementById('main-blog-roll').appendChild(createLoadingAnimation());

            fetchMorePosts(nextPage, requestQuery, requestQuerySignature)
                .then(function (data) {
                    renderMorePosts(data, loadMoreButton, nextPage, nextHref);
                })
                .catch(function () {
                    window.location.href = currentHref;
                });
        },
        {once: true}
    );
}

function renderMorePosts(responseData, buttonTemplate, currentPage, nextHref) {
    const loadingAnimation = document.getElementById('loading-animation');
    if (loadingAnimation) {
        loadingAnimation.remove();
    }

    const currentBlogRoll = document.getElementById('main-blog-roll').querySelector('.blog-roll');
    if (responseData.items_html) {
        currentBlogRoll.insertAdjacentHTML('beforeend', responseData.items_html);
    }

    if (responseData.next_page > 0) {
        const nextButton = buttonTemplate.cloneNode(true);
        nextButton.dataset.page = String(currentPage);
        nextButton.setAttribute('href', nextHref);
        document.getElementById('main-blog-roll').appendChild(nextButton);
        watchTheLoadMorePostsButton();
    }
}

function fetchMorePosts(page, query, querySignature) {
    if (
        !window.mbphotoMain ||
        typeof window.mbphotoMain.ajaxUrl !== 'string' ||
        window.mbphotoMain.ajaxUrl.length === 0
    ) {
        return Promise.reject(new Error('Missing AJAX URL.'));
    }

    const requestBody = new URLSearchParams();
    requestBody.append('action', 'mbphoto_load_more_posts');
    requestBody.append('page', String(page));
    requestBody.append('query', JSON.stringify(query));
    requestBody.append('query_signature', querySignature);

    return fetch(window.mbphotoMain.ajaxUrl, {
        method: 'POST',
        credentials: 'same-origin',
        body: requestBody
    })
        .then(function (response) {
            if (!response.ok) {
                throw new Error('Request failed.');
            }

            return response.json();
        })
        .then(function (payload) {
            if (!payload || !payload.success || !payload.data) {
                throw new Error('Invalid response.');
            }

            return payload.data;
        });
}

function parseLoadMoreQuery(encodedQuery) {
    if (!encodedQuery) {
        return {};
    }

    try {
        const parsedQuery = JSON.parse(encodedQuery);

        if (parsedQuery && typeof parsedQuery === 'object') {
            return parsedQuery;
        }
    } catch {
        return {};
    }

    return {};
}

function createLoadingAnimation() {
    const loadingAnimation = document.createElement('div');
    loadingAnimation.id = 'loading-animation';
    loadingAnimation.style.textAlign = 'center';

    const loadingImage = document.createElement('img');
    loadingImage.src = getLoadingImageUrl();
    loadingImage.alt = 'Loading more content';

    loadingAnimation.appendChild(loadingImage);

    return loadingAnimation;
}

function getLoadingImageUrl() {
    if (
        window.mbphotoMain &&
        typeof window.mbphotoMain.loadingImage === 'string' &&
        window.mbphotoMain.loadingImage.length > 0
    ) {
        return window.mbphotoMain.loadingImage;
    }

    return '/wp-content/themes/mitchellbennettphotography/assets/images/loading.svg';
}

function getIncrementedPageUrl(currentHref) {
    if (!currentHref) {
        return currentHref;
    }

    let url;
    try {
        url = new URL(currentHref, window.location.origin);
    } catch {
        return currentHref;
    }

    if (url.searchParams.has('paged')) {
        const currentPagedParam = Number.parseInt(url.searchParams.get('paged') || '1', 10);
        const nextPagedParam = Number.isNaN(currentPagedParam) ? 2 : currentPagedParam + 1;
        url.searchParams.set('paged', String(nextPagedParam));
        return url.toString();
    }

    const pagePattern = /\/page\/(\d+)\/?$/;
    if (pagePattern.test(url.pathname)) {
        url.pathname = url.pathname.replace(pagePattern, function (match, pageMatch) {
            const currentPathPage = Number.parseInt(pageMatch, 10);
            const nextPathPage = Number.isNaN(currentPathPage) ? 2 : currentPathPage + 1;
            return '/page/' + nextPathPage + '/';
        });
    }

    return url.toString();
}
